import SegmentedControl from '@alltrails/denali/components/SegmentedControl';
import Switch from '@alltrails/denali/components/Switch';
import ChipsFilterControl from './ChipsFilterControl';
import RangeSliderFilterControl from './RangeSliderFilterControl';
import SliderFilterControl from './SliderFilterControl';
import type { FilterConfigV2 } from './types';

type FilterControlV2Props = {
  filterConfig: FilterConfigV2;
};

const FilterControlV2 = ({ filterConfig }: FilterControlV2Props) => {
  switch (filterConfig.type) {
    case 'chips':
      return <ChipsFilterControl filterConfig={filterConfig} />;
    case 'toggle':
      return <Switch width="full" {...filterConfig.toggle} />;
    case 'segmented-control':
      return <SegmentedControl {...filterConfig.segmentedControl} />;
    case 'range-slider':
      return <RangeSliderFilterControl filterConfig={filterConfig} />;
    case 'slider':
      return <SliderFilterControl filterConfig={filterConfig} />;
    case 'custom':
      return <>{filterConfig.content}</>;
    default:
      return null;
  }
};

export default FilterControlV2;
